import { IActivityBase } from '../../models/activities';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUpdateActivityProps {
  activityId: string;
  bookingPrice?: number;
  description?: string;
  isActive?: boolean;
  isVerified?: boolean;
  name: string;
  spotId: string;
}

export type IUpdatedActivity = IActivityBase;

export const updateActivitiesService = async ({
  activityId,
  bookingPrice,
  description,
  isActive,
  isVerified,
  name,
  spotId,
}: IUpdateActivityProps): Promise<IUpdatedActivity> => {
  const { data } = await jhsfBookingsApi.put<IUpdatedActivity>(
    `/activities/${activityId}`,
    {
      bookingPrice,
      description,
      isActive,
      name,
      spotId,
    },
    { params: { isVerified } },
  );

  return data;
};
